import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Dashboard from "../Admin/Dashboard/Dashboard";
import CurrentDate from "../Admin/CurrentDate";
import ReactQuill from "react-quill";
import ImageWebp from "../../ImageWebp";
import Loader from "../Admin/Dashboard/Loader";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import baseApi from "../api";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactFileReader from "react-file-reader";
import "../../index.css";

const EditBlogCategory = (props) => {
  const [isLoading, setIsloading] = useState(false);
  const [data, setData] = useState({});
  const [preview, setPreview] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();
  // console.log("slug", slug);
  // console.log("preview", preview);

  useEffect(() => {
    axios.get(`${baseApi}meta-tags/${id}`).then((res) => {
      setData(res.data.data);
      setIsloading(false);
    });
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      slug: data.slug || "",
      title: data.title || "",
      keyword: data.keyword || "",
      description: data.description || "",
      canonicalUrl: data.canonicalUrl || "",
      og: {
        type: data.og?.type || "",
        url: data.og?.url || "",
        title: data.og?.title || "",
        description: data.og?.description || "",
        image: data.og?.image || ""
      },
      twitter: {
        card: data.twitter?.card || "",
        title: data.twitter?.title || "",
        description: data.twitter?.description || "",
        image: data.twitter?.image || ""
      },
      headerScripts: data.headerScripts || "",
      footerScripts: data.footerScripts || ""
    },
    validationSchema: Yup.object({
          slug: Yup.string()
            .required("Slug is required")
            .matches(/^[a-z0-9-\/]+$/, "Invalid slug format"),
        
          title: Yup.string()
            .required("Title is required")
            .max(70, "Max 70 characters"),
        
          keyword: Yup.string()
            .required("Keywords are required"),
        
          description: Yup.string()
            .required("Description is required")
            .max(160, "Max 160 characters"),
        
          canonicalUrl: Yup.string()
            .url("Invalid URL")
            .nullable(),
        
          // ✅ Open Graph (optional but validated if present)
          og: Yup.object({
            type: Yup.string().nullable(),
            url: Yup.string().url("Invalid OG URL").nullable(),
            title: Yup.string().nullable(),
            description: Yup.string().nullable(),
            image: Yup.string().url("Invalid OG image URL").nullable()
          }),
        
          // ✅ Twitter (optional)
          twitter: Yup.object({
            card: Yup.string().nullable(),
            title: Yup.string().nullable(),
            description: Yup.string().nullable(),
            image: Yup.string().url("Invalid Twitter image URL").nullable()
          }),
        
          // ✅ Scripts (optional)
          headerScripts: Yup.string()
            .max(5000, "Header script too large")
            .nullable(),
        
          footerScripts: Yup.string()
            .max(5000, "Footer script too large")
            .nullable()
        }),
    onSubmit: async (values) => {
      try {
        setIsloading(true);
    
        await axios.post(`${baseApi}meta-tags/`, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwtToken")}`
          }
        });
    
    
        setIsloading(false);
        formik.resetForm();
    
      } catch (err) {
        console.log(err);
        setIsloading(false);
      }
  }
});

  return (
    <Fragment>
      <div className="admin_panel">
        <Dashboard />

        {!isLoading ? (
          <div className="container">
                        <div className="col-sm-12">
                          <CurrentDate />
                    
                          <form onSubmit={formik.handleSubmit}>
                    
                            {/* Slug */}
                            <div className="form-group">
                              <label><h3>Slug</h3></label>
                              <input
                                type="text"
                                className="form-control"
                                name="slug"
                                {...formik.getFieldProps("slug")}
                              />
                            </div>
                    
                            {/* Title */}
                            <div className="form-group">
                              <label><h3>Title</h3></label>
                              <input
                                type="text"
                                className="form-control"
                                name="title"
                                {...formik.getFieldProps("title")}
                              />
                            </div>
                    
                            {/* Keywords */}
                            <div className="form-group">
                              <label><h3>Keywords</h3></label>
                              <input
                                type="text"
                                className="form-control"
                                name="keyword"
                                {...formik.getFieldProps("keyword")}
                              />
                            </div>
                    
                            {/* Description */}
                            <div className="form-group">
                              <label><h3>Description</h3></label>
                              <textarea
                                className="form-control"
                                name="description"
                                rows="3"
                                {...formik.getFieldProps("description")}
                              />
                            </div>
                    
                            {/* Canonical URL */}
                            <div className="form-group">
                              <label><h3>Canonical URL</h3></label>
                              <input
                                type="text"
                                className="form-control"
                                name="canonicalUrl"
                                {...formik.getFieldProps("canonicalUrl")}
                              />
                            </div>
                    
                            <hr />
                    
                            {/* OG TAGS */}
                            <h4>Open Graph (OG)</h4>
                    
                            <input className="form-control mb-2" placeholder="OG Type" name="og.type" {...formik.getFieldProps("og.type")} />
                            <input className="form-control mb-2" placeholder="OG URL" name="og.url" {...formik.getFieldProps("og.url")} />
                            <input className="form-control mb-2" placeholder="OG Title" name="og.title" {...formik.getFieldProps("og.title")} />
                            <input className="form-control mb-2" placeholder="OG Description" name="og.description" {...formik.getFieldProps("og.description")} />
                            <input className="form-control mb-2" placeholder="OG Image" name="og.image" {...formik.getFieldProps("og.image")} />
                    
                            <hr />
                    
                            {/* TWITTER TAGS */}
                            <h4>Twitter</h4>
                    
                            <input className="form-control mb-2" placeholder="Twitter Card" name="twitter.card" {...formik.getFieldProps("twitter.card")} />
                            <input className="form-control mb-2" placeholder="Twitter Title" name="twitter.title" {...formik.getFieldProps("twitter.title")} />
                            <input className="form-control mb-2" placeholder="Twitter Description" name="twitter.description" {...formik.getFieldProps("twitter.description")} />
                            <input className="form-control mb-2" placeholder="Twitter Image" name="twitter.image" {...formik.getFieldProps("twitter.image")} />
                    
                            <hr />
                    
                            {/* Header Scripts */}
                            <div className="form-group">
                              <label><h3>Header Scripts</h3></label>
                              <textarea
                                className="form-control"
                                name="headerScripts"
                                rows="4"
                                placeholder="<script>...</script>"
                                {...formik.getFieldProps("headerScripts")}
                              />
                            </div>
                    
                            {/* Footer Scripts */}
                            <div className="form-group">
                              <label><h3>Footer Scripts</h3></label>
                              <textarea
                                className="form-control"
                                name="footerScripts"
                                rows="4"
                                {...formik.getFieldProps("footerScripts")}
                              />
                            </div>
          
                <hr />

                <div className="form-group">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Update Schema"
                  />
                  &nbsp;&nbsp;
                  <Link to="/blog-category">Back to website schema</Link>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    </Fragment>
  );
};

export default EditBlogCategory;
